import React from 'react'
import './skills.css'
import { FaPython } from "react-icons/fa"
import { SiTensorflow } from "react-icons/si"
import { SiKeras } from "react-icons/si"
import { FaBrain } from "react-icons/fa"
import { SiScikitlearn } from "react-icons/si"
import { RiAiGenerate } from "react-icons/ri"
import { SiOpencv } from "react-icons/si"
import { GiBrain } from "react-icons/gi"
import { BiNetworkChart } from "react-icons/bi"
import { IoMdAnalytics } from "react-icons/io"
import { AiOutlineClear } from "react-icons/ai"
import { IoCreate } from "react-icons/io5"
import { TbPresentationAnalytics } from "react-icons/tb"
import { MdOutlineRecommend } from "react-icons/md"
import { FaRProject } from "react-icons/fa"
import { TbFileTypeSql } from "react-icons/tb"
import { FaReact } from "react-icons/fa"
import { SiFastapi } from "react-icons/si"
import { SiStreamlit } from "react-icons/si"
import { FaGitAlt } from "react-icons/fa"
import { SiMongodb } from "react-icons/si"

const Skills = () => {
  return (
    <section id='skills'>
      <h5>Here Is My</h5>
      <h2>Skills</h2>
      <div className="container skills__container">
        <div className="skills__cards">

          <div className="skills__card">
            <h4>Machine Learning & AI</h4>
            <div className="skills_content">
              <article className='skills_details'>
              <SiTensorflow  className='skills__icon'/>
              <h5>TensorFlow</h5>
              </article>
              <article className='skills_details'>
                <SiKeras  className='skills__icon'/>
                <h5>Keras</h5>
              </article>
              <article className='skills_details'>
                <SiScikitlearn className='skills__icon'/>
                <h5>Scikit-learn</h5>
              </article>
              <article className='skills_details'>
                <BiNetworkChart className='skills__icon'/>
                <h5>Deep Learning </h5>
              </article>
              <article className='skills_details'>
                <FaBrain className='skills__icon'/>
                <h5>LLMs</h5>
              </article>
              <article className='skills_details'>
                <GiBrain className='skills__icon'/>
                <h5>NLP</h5>
              </article>
              <article className='skills_details'>
                <SiOpencv  className='skills__icon'/>
                <h5>Computer Vision</h5>
              </article>
              <article className='skills_details'>
                <RiAiGenerate className='skills__icon'/>
                <h5>Generative AI</h5>
              </article>
            </div>
          </div>

          <div className="skills__card">
            <h4>Data Science & Analytics</h4>
            <div className="skills_content">
              <article className='skills_details'>
              <IoMdAnalytics className='skills__icon'/>
              <h5>Data Analysis</h5>
              </article>
              <article className='skills_details'>
                <AiOutlineClear className='skills__icon'/>
                <h5>Data Cleaning</h5>
              </article>
              <article className='skills_details'>
                <IoCreate className='skills__icon'/>
                <h5>Feature Engineering</h5>
              </article>
              <article className='skills_details'>
                <MdOutlineRecommend  className='skills__icon'/>
                <h5>Recommender Systems</h5>
              </article>
              <article className='skills_details'>
                <TbPresentationAnalytics className='skills__icon'/>
                <h5>Data Visualisation</h5>
              </article>
            </div>
          </div>

          <div className="skills__card">
            <h4>Programming & Development</h4>
            <div className="skills_content">
              <article className='skills_details'>
              <FaPython className='skills__icon'/>
              <h5>Python</h5>
              </article>
              <article className='skills_details'>
                <FaRProject className='skills__icon'/>
                <h5>R</h5>
              </article>
              <article className='skills_details'>
                <TbFileTypeSql className='skills__icon'/>
                <h5>SQL</h5>
              </article>
              <article className='skills_details'>
                <FaReact className='skills__icon'/>
                <h5>React.js</h5>
              </article>
              <article className='skills_details'>
                <SiFastapi className='skills__icon'/>
                <h5>FastAPI</h5>
              </article>
              <article className='skills_details'>
                <SiStreamlit className='skills__icon'/>
                <h5>Streamlit</h5>
              </article>
              <article className='skills_details'>
                <FaGitAlt className='skills__icon'/>
                <h5>Git/GitHub</h5>
              </article>
              <article className='skills_details'>
                <SiMongodb className='skills__icon'/>
                <h5>MongoDB</h5>
              </article>
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}

export default Skills